const scale = {
  a: [
    {
      value: 1,
      label: 'sangat sesuai',
    },
    {
      value: 2,
      label: 'sesuai',
    },
    {
      value: 3,
      label: 'kurang sesuai',
    },
    {
      value: 4,
      label: 'tidak sesuai',
    },
  ],
  b: [
    {
      value: 1,
      label: 'sangat relevan',
    },
    {
      value: 2,
      label: 'relevan',
    },
    {
      value: 3,
      label: 'kurang relevan',
    },
    {
      value: 4,
      label: 'tidak relevan',
    },
  ],
  c: [
    {
      value: 1,
      label: 'Guru Ahli Pertama (Gol. III/a,III/b)',
    },
    {
      value: 2,
      label: 'Guru Ahli Muda (Gol. III/c,III/d)',
    },
    {
      value: 3,
      label: 'Guru Ahli Madya (Gol. IV/a, IV/b, IV/c)',
    },
    {
      value: 4,
      label: 'Guru Ahli Utama(Gol. IV/d, IV/e)',
    },
  ],
  d: [
    {
      value: 1,
      label: 'selalu',
    },
    {
      value: 2,
      label: 'sering',
    },
    {
      value: 3,
      label: 'jarang',
    },
    {
      value: 4,
      label: 'tidak pernah',
    },
  ],
}

const questionTypeA = [
  {
    order: 'a',
    question: 'Apakah tugas ini dilaksanakan dalam pekerjaan sehari-hari?',
    questionScale: scale.d,
  },
  {
    order: 'b',
    question:
      'Menurut anda apakah tugas ini relevan dengan arah perubahan merdeka belajar?',
    questionScale: scale.b,
  },
  {
    order: 'c',
    question:
      'Apa jenjang minimal dari jabatan guru yang kompeten mengerjakan tugas ini?',
    questionScale: scale.c,
  },
]
const questionTypeB = [
  {
    order: 'a',
    question:
      'Apakah deskripsi perilaku ini sesuai dengan perilaku Anda dalam pekerjaan sehari-hari?',
    questionScale: scale.a,
  },
  {
    order: 'b',
    question:
      'Apakah deskripsi perilaku ini relevan dengan arah perubahan merdeka belajar?',
    questionScale: scale.b,
  },
  {
    order: 'c',
    question:
      'Apa jenjang jabatan minimal yang selayaknya menguasai deskripsi perilaku ini?',
    questionScale: scale.c,
  },
]

const questionTugasGuruPerjenjang = [
  {
    id: 1,
    text: 'Merumuskan tujuan pembelajaran/pembimbingan yang akan dicapai ',
    items: questionTypeA,
  },
  {
    id: 2,
    text: 'Merencanakan asesmen pembelajaran/evaluasi pembimbingan yang digunakan',
    items: questionTypeA,
  },
  {
    id: 3,
    text: 'Merencanakan strategi pembelajaran/pembimbingan yang digunakan ',
    items: questionTypeA,
  },
  {
    id: 4,
    text: 'Merumuskan tujuan pembelajaran/pembimbingan sesuai dengan tahap penguasaan kompetensi/tahap perkembangan peserta didik',
    items: questionTypeA,
  },
  {
    id: 5,
    text: 'Merencanakan penggunaan sejumlah asesmen pembelajaran/evaluasi pembimbingan yang relevan dengan tujuan pembelajaran/pembimbingan ',
    items: questionTypeA,
  },
  {
    id: 6,
    text: 'Merencanakan penggunaan sejumlah strategi pembelajaran/pembimbingan yang inklusif dalam mengakomodasi keragaman peserta didik ',
    items: questionTypeA,
  },
  {
    id: 7,
    text: 'Merumuskan tujuan pembelajaran/pembimbingan yang bermakna, terdiferensiasi dan menantang sesuai dengan tahap penguasaan kompetensi/tahap perkembangan peserta didik dan refleksi pembelajaran/pembimbingan sebelumnya',
    items: questionTypeA,
  },
  {
    id: 8,
    text: 'Merencanakan sejumlah asesmen pembelajaran/evaluasi pembimbingan yang relevan dengan tujuan pembelajaran/pembimbingan dalam membangun kebiasaan refleksi belajar pada peserta didik ',
    items: questionTypeA,
  },
  {
    id: 9,
    text: 'Merencanakan penggunaan strategi pembelajaran/pembimbingan yang inkusif dan berdiferensiasi, dan memfasilitasi peserta didik mempunyai pilihan cara belajar ',
    items: questionTypeA,
  },
  {
    id: 10,
    text: 'Merumuskan tujuan pembelajaran/pembimbingan yang bermakna, terdiferensiasi dan menantang sesuai dengan tahap penguasaan kompetensi/tahap perkembangan peserta didik, refleksi pembelajaran/pembimbingan sebelumnya yang melibatkan peserta didik ',
    items: questionTypeA,
  },
  {
    id: 11,
    text: 'Merencanakan asesmen pembelajaran/evaluasi pembimbingan yang relevan dengan tujuan pembelajaran/pembimbingan dalam membangun kebiasaan refleksi belajar pada peserta didik yang melibatkan peserta didik dalam membangun budaya belajar ',
    items: questionTypeA,
  },
  {
    id: 12,
    text: 'Merencanakan penggunaan strategi pembelajaran/pembimbingan yang inkusif dan berdiferensiasi, dan memfasilitasi pelibatan peserta didik dalam menentukan strategi pembelajaran ',
    items: questionTypeA,
  },
  {
    id: 13,
    text: 'Melaksanakan upaya mewujudkan lingkungan belajar yang aman dan nyaman',
    items: questionTypeA,
  },
  {
    id: 14,
    text: 'Melaksanakan proses penguasaan tujuan pembelajaran',
    items: questionTypeA,
  },
  {
    id: 15,
    text: 'Melaksanakan proses mengikutsertakan orang tua/wali peserta didik',
    items: questionTypeA,
  },
  {
    id: 16,
    text: 'Melaksanakan upaya mewujudkan lingkungan belajar yang aman dan nyaman dengan melibatkan peserta didik dalam menetapkan kesepakatan kelas',
    items: questionTypeA,
  },
  {
    id: 17,
    text: 'Melaksanakan proses pencapaian tujuan pembelajaran dengan mengupayakan setiap peserta didik terlibat aktif menyampaikan pendapat dalam aktivitas pembelajaran ',
    items: questionTypeA,
  },
  {
    id: 18,
    text: 'Melaksanakan proses mengikutsertakan orang tua/wali peserta didik dengan menyediakan pilihan peran yang bermakna',
    items: questionTypeA,
  },
  {
    id: 19,
    text: 'Melaksanakan upaya mewujudkan lingkungan belajar yang aman dan nyaman dengan mengaktifkan peran peserta didik dalam membangun kebiasaan kelas',
    items: questionTypeA,
  },
  {
    id: 20,
    text: 'Melaksanakan proses pencapaian tujuan pembelajaran dengan mengupayakan diferensiasi pembelajaran sesuai kebutuhan, kesiapan dan kompetensi peserta didik ',
    items: questionTypeA,
  },
  {
    id: 21,
    text: 'Melaksanakan proses mengikutsertakan orang tua/wali peserta didik dengan menyediakan kesempatan mengelola sebuah kegiatan/program',
    items: questionTypeA,
  },
  {
    id: 22,
    text: 'Melaksanakan upaya mewujudkan lingkungan belajar yang aman dan nyaman dengan menciptakan peran dan kesempatan kepemimpinan bagi peserta didik dalam membangun kebiasaan kelas dan satuan pendidikan',
    items: questionTypeA,
  },
  {
    id: 23,
    text: 'Melaksanakan proses pencapaian tujuan pembelajaran dengan melibatkan peserta didik berdiskusi memutuskan tujuan, cara dan penilaian pembelajaran serta refleksi sepanjang masa pembelajaran',
    items: questionTypeA,
  },
  {
    id: 24,
    text: 'Melaksanakan proses mengikutsertakan orang tua/wali peserta didik dengan menyediakan kesempatan menginisiasi dan memimpin sebuah kegiatan/program',
    items: questionTypeA,
  },
  {
    id: 25,
    text: 'Melaksanakan minimal 1 asesmen pembelajaran/evaluasi pembimbingan yang relevan dengan tujuan pembelajaran/pembimbingan',
    items: questionTypeA,
  },
  {
    id: 26,
    text: 'Mengomunikasikan hasil asesmen pembelajaran/evaluasi pembimbingan sebagai umpan balik kepada peserta didik',
    items: questionTypeA,
  },
  {
    id: 27,
    text: 'Mengomunikasikan laporan hasil belajar/bimbingan kepada orang tua/wali peserta didik',
    items: questionTypeA,
  },
  {
    id: 28,
    text: 'Melaksanakan beragam asesmen pembelajaran/evaluasi pembimbingan yang relevan dengan tujuan pembelajaran/pembimbingan ',
    items: questionTypeA,
  },
  {
    id: 29,
    text: 'Mengomunikasikan hasil akhir dari beragam asesmen pembelajaran/evaluasi pembimbingan dalam beberapa bentuk mudah dipahami sebagai umpan balik kepada peserta didik',
    items: questionTypeA,
  },
  {
    id: 30,
    text: 'Mengkomunikasikan laporan hasil belajar/bimbingan kepada peserta didik dan orang tua/wali peserta didik',
    items: questionTypeA,
  },
  {
    id: 31,
    text: 'Melaksanakan beragam asesmen pembelajaran/evaluasi pembimbingan yang relevan dengan tujuan pembelajaran untuk membangun kebiasaan refleksi belajar pada peserta didik',
    items: questionTypeA,
  },
  {
    id: 32,
    text: 'Mengomunikasikan hasil akhir dari beragam asesmen pembelajaran/evaluasi pembimbingan dilengkapi hasil analisis sederhana dalam bentuk mudah dipahami sebagai umpan balik kepada peserta didik',
    items: questionTypeA,
  },
  {
    id: 33,
    text: 'Memfasilitasi komunikasi laporan hasil belajar/bimbingan oleh peserta didik kepada orang tua/wali peserta didik',
    items: questionTypeA,
  },
  {
    id: 34,
    text: 'Melaksanakan beragam asesmen pembelajaran/evaluasi pembimbingan yang relevan dengan tujuan pembelajaran dan melibatkan peserta didik untuk membangun budaya belajar',
    items: questionTypeA,
  },
  {
    id: 35,
    text: 'Mengomunikasikan hasil dari beragam asesmen pembelajaran/evaluasi pembimbingan dilengkapi hasil analisis kompleks dalam bentuk mudah dipahami dan interaktif sebagai umpan balik kepada peserta didik',
    items: questionTypeA,
  },
  {
    id: 36,
    text: 'Memfasilitasi komunikasi laporan hasil belajar/bimbingan oleh peserta didik kepada orang tua/wali peserta didik dan masyarakat',
    items: questionTypeA,
  },
]

const questionKompetensiPedagogik = [
  {
    id: 1,
    text: 'Menjelaskan konsep dan strategi manajemen kelas yang berorientasi pada peserta didik untuk mewujudkan kenyamanan dan keamanan belajar.',
    items: questionTypeB,
  },
  {
    id: 2,
    text: 'Menggunakan strategi manajemen kelas yang berorientasi pada peserta didik secara efektif untuk mewujudkan kenyamanan dan keamanan belajar.',
    items: questionTypeB,
  },
  {
    id: 3,
    text: 'Menganalisis berbagai strategi dan memadukan lebih dari 1 strategi manajemen kelas termasuk komunikasi positif dan kesepakatan kelas untuk mengembangkan lingkungan kelas yang aman dan nyaman',
    items: questionTypeB,
  },
  {
    id: 4,
    text: 'Menilai berbagai praktik baik pembelajaran untuk mengembangkan strategi manajemen kelas sehingga kelas berkembang menjadi sistem sosial yang mampu dan mau belajar secara mandiri.',
    items: questionTypeB,
  },
  {
    id: 5,
    text: 'Menjadi pembimbing bagi guru lain dalam menggunakan dan mengembangkan berbagai strategi manajemen kelas sehingga kelas berkembang menjadi sistem sosial yang mampu dan mau belajar secara mandiri',
    items: questionTypeB,
  },
  {
    id: 6,
    text: 'Menjelaskan konsep dan strategi perencanaan, pelaksanaan, asesmen dan laporan pembelajaran yang berorientasi pada peserta didik melalui penggunaan teknologi secara adaptif.',
    items: questionTypeB,
  },
  {
    id: 7,
    text: 'Melakukan perencanaan, pelaksanaan, asesmen dan laporan pembelajaran yang berorientasi pada peserta didik melalui penggunaan teknologi secara adaptif.',
    items: questionTypeB,
  },
  {
    id: 8,
    text: 'Menganalisis berbagai strategi dan memadukan lebih dari 1 strategi perencanaan, pelaksanaan, asesmen dan laporan pembelajaran yang berorientasi pada peserta didik melalui penggunaan teknologi secara adaptif untuk mencapai efektivitas pembelajaran.',
    items: questionTypeB,
  },
  {
    id: 9,
    text: 'Menilai berbagai praktik baik pembelajaran untuk mengembangkan strategi  perencanaan, pelaksanaan, asesmen dan laporan pembelajaran yang berorientasi pada peserta didik melalui penggunaan teknologi secara adaptif untuk mencapai efektivitas pembelajaran',
    items: questionTypeB,
  },
  {
    id: 10,
    text: 'Menjadi pembimbing bagi guru lain dalam menggunakan dan mengembangkan berbagai strategi perencanaan, pelaksanaan, asesmen dan laporan pembelajaran yang berorientasi pada peserta didik melalui penggunaan teknologi secara adaptif untuk mencapai efektivitas pembelajaran.',
    items: questionTypeB,
  },
  {
    id: 11,
    text: 'Menjelaskan konsep dan peran pelibatan orang tua/wali dan masyarakat dalam pembelajaran yang berorientasi pada peserta didik',
    items: questionTypeB,
  },
  {
    id: 12,
    text: 'Melakukan pelibatan orangtua/wali dan masyarakat dalam pembelajaran yang berorientasi pada peserta didik.',
    items: questionTypeB,
  },
  {
    id: 13,
    text: 'Menganalisis berbagai strategi dan memadukan lebih dari 1 strategi pelibatan untuk mengembangkan kesempatan bagi orang tua/wali peserta didik dan masyarakat untuk aktif terlibat dalam pembelajaran yang berorientasi pada peserta didik, bermakna dan sesuai konteks.',
    items: questionTypeB,
  },
  {
    id: 14,
    text: 'Menilai berbagai praktik baik pembelajaran untuk mengembangkan strategi  kolaborasi dengan guru lain dalam menyediakan kesempatan bagi orang tua/wali peserta didik dan masyarakat untuk aktif terlibat dalam pembelajaran yang berorientasi pada peserta didik, bermakna dan sesuai konteks',
    items: questionTypeB,
  },
  {
    id: 15,
    text: 'Menjadi pembimbing bagi guru lain dalam menyediakan kesempatan bagi orang tua/wali peserta didik dan masyarakat untuk aktif terlibat dalam pembelajaran yang berorientasi pada peserta didik, bermakna dan sesuai konteks.',
    items: questionTypeB,
  },
]

const questionKompetensiProfesional = [
  {
    id: 1,
    text: 'Memahami struktur dan alur pengetahuan untuk pembelajaran',
    items: questionTypeB,
  },
  {
    id: 2,
    text: 'Menyusun analisis struktur dan alur pengetahuan serta tahap penguasaan kompetensi peserta didik',
    items: questionTypeB,
  },
  {
    id: 3,
    text: 'Menelaah tujuan pembelajaran berdasarkan analisis struktur dan alur pengetahuan serta tahap penguasaan kompetensi peserta didik',
    items: questionTypeB,
  },
  {
    id: 4,
    text: 'Menilai proses dan hasil pembelajaran untuk memperbaiki dan mengembangkan analisis terhadap struktur dan alur pengetahuan yang urut dan meningkat kompleksitasnya',
    items: questionTypeB,
  },
  {
    id: 5,
    text: 'Menjadi pembimbing bagi guru lain dalam menyusun alur belajar yang meningkat kompleksitasnya berdasarkan urutan konsep dari suatu disiplin ilmu maupun lintas disiplin',
    items: questionTypeB,
  },
  {
    id: 6,
    text: 'Menjelaskan teori perkembangan peserta didik, tahap perkembangan peserta didik dan latar belakang yang berdampak pada proses belajar',
    items: questionTypeB,
  },
  {
    id: 7,
    text: 'Melakukan asesmen diagnosis tahap perkembangan kompetensi peserta didik berdasarkan pemahaman terhadap proses belajar, kebutuhan, dan latar belakang peserta didik',
    items: questionTypeB,
  },
  {
    id: 8,
    text: 'Menelaah berbagai strategi dan memadukan lebih dari 1 strategi asesmen diagnosis tahap penguasaan kompetensi peserta didik, kebutuhan peserta didik, dan latar belakang peserta didik untuk menetapkan tujuan pembelajaran ',
    items: questionTypeB,
  },
  {
    id: 9,
    text: 'Menilai proses dan hasil pembelajaran untuk memperbaiki dan mengembangkan strategi asesmen diagnosis tahap penguasaan kompetensi peserta didik, kebutuhan peserta didik, latar belakang peserta didik sebagai dasar menetapkan tujuan pembelajaran',
    items: questionTypeB,
  },
  {
    id: 10,
    text: 'Menjadi pembimbing bagi guru lain dalam mengembangkan asesmen diagnosis tahap perkembangan kompetensi peserta didik berdasarkan pemahaman terhadap proses belajar, kebutuhan, tahap perkembangan, dan latar belakang peserta didik untuk menetapkan tujuan pembelajaran ',
    items: questionTypeB,
  },
  {
    id: 11,
    text: 'Memahami cara menetapkan tujuan pembelajaran sebagai acuan dalam menetapkan asesmen dan strategi pembelajaran.',
    items: questionTypeB,
  },
  {
    id: 12,
    text: 'Menetapkan tujuan pembelajaran berdasarkan analisis struktur dan alur pengetahuan, tahap penguasaan kompetensi peserta didik, kurikulum, dan nilai-nilai Pancasila',
    items: questionTypeB,
  },
  {
    id: 13,
    text: 'Menelaah tujuan pembelajaran berdasarkan analisis struktur dan alur pengetahuan, tahap penguasaan kompetensi peserta didik, kurikulum, dan nilai-nilai Pancasila sebagai acuan dalam strategi dan asesmen pembelajaran ',
    items: questionTypeB,
  },
  {
    id: 14,
    text: 'Menilai proses dan hasil pembelajaran untuk memperbaiki dan mengembangkan cara kerja penyusunan tujuan pembelajaran yang bervariasi, menantang, dan realistis sebagai acuan dalam strategi dan asesmen pembelajaran yang tepat dan berdiferensiasi',
    items: questionTypeB,
  },
  {
    id: 15,
    text: 'Menjadi pembimbing bagi guru lain menetapkan tujuan pembelajaran yang bervariasi, menantang, dan realistis sesuai dengan perkembangan peserta didik, kebijakan kurikulum, dan nilai-nilai Pancasila sebagai acuan dalam strategi dan asesmen pembelajaran yang tepat dan berdiferensiasi.',
    items: questionTypeB,
  },
]

const questionKompetensiPengembanganProfesi = [
  {
    id: 1,
    text: 'Memahami manfaat kebiasaan refleksi untuk mengetahui aspek kekuatan dan kelemahan sebagai pendidik',
    items: questionTypeB,
  },
  {
    id: 2,
    text: 'Menerapkan refleksi terhadap praktik pembelajaran dan pendidikan yang berorientasi pada peserta didik untuk mengetahui aspek kekuatan dan kelemahan sebagai pendidik',
    items: questionTypeB,
  },
  {
    id: 3,
    text: 'Menganalisis refleksi terhadap praktik pembelajaran dan pendidikan berdasarkan penilaian diri dan umpan balik dari peserta didik sehingga dapat menganalisis aspek kekuatan dan kelemahan dalam melakukan pengembangan profesi',
    items: questionTypeB,
  },
  {
    id: 4,
    text: 'Menilai berbagai praktik baik pembelajaran untuk mengembangkan strategi refleksi terhadap praktik pembelajaran dan pendidikan berdasarkan penilaian diri dan umpan balik dari peserta didik dan/atau rekan kerja sehingga dapat menganalisis aspek kekuatan dan kelemahan sebagai guru dalam melakukan pengembangan profesi yang berdampak pada peningkatan kualitas pembelajaran dan pendidikan',
    items: questionTypeB,
  },
  {
    id: 5,
    text: 'Merancang refleksi kolaboratif dengan warga sekolah secara berkala terhadap praktik pembelajaran dan pendidikan sehingga dapat menganalisis aspek kekuatan dan kelemahan sebagai guru dalam melakukan pengembangan profesi yang berdampak pada peningkatan kualitas pembelajaran dan pendidikan.',
    items: questionTypeB,
  },
  {
    id: 6,
    text: 'Memahami hak peserta didik dan bagaimana cara berinteraksi aktif dengan peserta didik.',
    items: questionTypeB,
  },
  {
    id: 7,
    text: 'Menerapkan refleksi terhadap cara berinteraksi aktif dengan peserta didik yang menjaga dan menghormati hak peserta didik dalam menjalankan peran pendidik',
    items: questionTypeB,
  },
  {
    id: 8,
    text: 'Menganalisis hasil refleksi terhadap interaksi aktif dengan peserta didik yang menjaga dan menghormati hak peserta didik, serta memastikan keselamatan dan keamanan semua peserta didik, baik sebagai individu maupun kelompok ',
    items: questionTypeB,
  },
  {
    id: 9,
    text: 'Menilai berbagai praktik baik pembelajaran untuk mengembangkan strategi refleksi terhadap praktik dan kebiasaan bekerja serta memberikan respons yang berpihak pada peserta didik dengan menjaga dan menghormati hak peserta didik ketika peserta didik, baik sebagai individu maupun kelompok, menghadapi situasi yang mengancam keselamatan dan keamanannya',
    items: questionTypeB,
  },
  {
    id: 10,
    text: 'Mengembangkan sistem kolaborasi bersama guru lain untuk melakukan refleksi praktik dan kebiasaan bekerja untuk meningkatkan kualitas kerja yang menjaga dan menghormati hak peserta didik, serta memastikan keselamatan dan keamanan peserta didik, baik sebagai individu maupun kelompok',
    items: questionTypeB,
  },
  {
    id: 11,
    text: 'Memahami konsep karier bagi pendidik',
    items: questionTypeB,
  },
  {
    id: 12,
    text: 'Menerapkan refleksi dalam menjalankan peran sesuai kebutuhan pengembangan karier pada kegiatan jejaring dan organisasi profesi yang berorientasi pada peserta didik',
    items: questionTypeB,
  },
  {
    id: 13,
    text: 'Menganalisis hasil refeksi menjalankan beragam peran dalam kegiatan jejaring dan organisasi profesi untuk mengeksplorasi peran yang relevan dengan kebutuhan dan tahap pengembangan kariernya.',
    items: questionTypeB,
  },
  {
    id: 14,
    text: 'Menilai berbagai praktik baik pembelajaran untuk membuat karya dan/atau memberikan layanan bermakna yang dikelola dan dibagikan melalui beragam peran aktif dalam kegiatan jejaring dan organisasi profesi yang relevan dengan kebutuhan dan tahap pengembangan kariernya',
    items: questionTypeB,
  },
  {
    id: 15,
    text: 'Menjadi pembimbing bagi guru lain dalam membuat karya dan/atau memberikan layanan yang bermakna yang dikelola dan dibagikan melalui beragam peran aktif dalam kegiatan jejaring dan organisasi profesi yang relevan dengan kebutuhan belajar untuk mengembangkan kariernya.',
    items: questionTypeB,
  },
]

const instrumentList = [
  'instrumen_tugas_guru_per_jenjang_jabatan',
  'instrumen_kompetensi_pedagogik',
  'instrumen_kompetensi_profesional',
  'instrumen_kompetensi_pengembangan_profesi',
]

const questionsByInstrument = [
  {
    type: instrumentList[0],
    questions: questionTugasGuruPerjenjang,
  },
  {
    type: instrumentList[1],
    questions: questionKompetensiPedagogik,
  },
  {
    type: instrumentList[2],
    questions: questionKompetensiProfesional,
  },
  {
    type: instrumentList[3],
    questions: questionKompetensiPengembanganProfesi,
  },
]

export interface IQuestionType {
  order: string
  question: string
  questionScale: {
    value: string | number
    label: string
  }[]
}

export interface IInstrumentQuestions {
  id: number
  text: string
  items: IQuestionType[]
}

export { instrumentList, questionsByInstrument, scale }
